// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"289":"9d0212cb","538":"bc6a3996","636":"873bfea0","784":"a45cbbe9"}[chunkId] + ".chunk.css";
};